module.exports = {
  useNativeCanvas: false
};